import React from 'react';
import './Contactus.css';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';

export default function Contactus() {
  return (
    <div className="contactus-container">
      {/* Hero Section */}
      <div className="contactus-hero">
        <div className="contactus-hero-content">
          <h1 className="contactus-hero-title">Contact Us</h1>
          <p className="contactus-hero-subtitle">We'd love to hear from you. Get in touch with us today!</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contactus-content">
        {/* Contact Information Section */}
        <div className="contactus-info-wrapper">
          <h2 className="contactus-section-title">Get In Touch</h2>
          
          <div className="contactus-info-cards">
            {/* Email Card */}
            <div className="contactus-info-card">
              <div className="contactus-icon-wrapper">
                <Mail className="contactus-icon" />
              </div>
              <h3 className="contactus-card-title">Email Us</h3>
              <a href="mailto:info@aultrapaints.com" className="contactus-link">info@aultrapaints.com</a>
              <a href="mailto:aultratek@yahoo.co.in" className="contactus-link">aultratek@yahoo.co.in</a>
            </div>

            {/* Phone Card */}
            <div className="contactus-info-card">
              <div className="contactus-icon-wrapper">
                <Phone className="contactus-icon" />
              </div>
              <h3 className="contactus-card-title">Call Us</h3>
              <a href="tel:9290100586" className="contactus-link">9290100586</a>
              <a href="tel:9949233556" className="contactus-link">9949233556</a>
            </div>

            {/* Address Card */}
            <div className="contactus-info-card">
              <div className="contactus-icon-wrapper">
                <MapPin className="contactus-icon" />
              </div>
              <h3 className="contactus-card-title">Visit Us</h3>
              <p className="contactus-address">
                4th Floor, 5-9-265/1A/NR SY No 199/F,<br />
                Plot No 14, Prashanthi Nagar,<br />
                Rajeev Gandhi Nagar, Kukatpally,<br />
                Hyderabad - 500072
              </p>
            </div>
          </div>

          {/* Social Media */}
          <div className="contactus-social-section">
            <h3 className="contactus-social-title">Follow Us</h3>
            <div className="contactus-social-links">
              <a href="https://facebook.com/aultrapaints" className="contactus-social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <Facebook />
              </a>
              <a href="https://instagram.com/aultrapaints" className="contactus-social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <Instagram />
              </a>
              <a href="https://youtube.com/@aultrapaints" className="contactus-social-link" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                <Youtube />
              </a>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="contactus-map-section">
          <h2 className="contactus-section-title">Find Us On Map</h2>
          <div className="contactus-map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.5406175755006!2d78.42869!3d17.481688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91acf46acc4d%3A0xd3d9ce51ca4e3a86!2sAultra%20Paints!5e0!3m2!1sen!2sin!4v1759921773416!5m2!1sen!2sin"
              className="contactus-map"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Aultra Paints Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}